import { atom, selector, useRecoilState } from 'recoil';

const articlesState = atom({
  key: 'articlesState',
  default: selector({
    key: "selectorArticlesState",
    get: async ({ get }) => {
      const response = await fetch(`${process.env.REACT_APP_PATH_LOCAL}wp-json/wp/v2/measure`);
      if (response.error) {
        throw response.error;
      }
      const res = await response.json();
      console.log(res)
      return res
    },
  })
})

export const articlesTypeState = atom({
  key: 'articlesTypeState',
  default: 'mc',
})


// const articlesByCatState = selector({
//   key: 'articlesByCatState',
//   get: ({ get }) => {
//     const list = get(articlesState);
//     const { catList } = UsequestionsState();

//     let articlesByCatItem =[];
//     let articlesByCat = [];

//     catList.filter((cat)=> {
//       articlesByCatItem = list.filter((item) => {
//         const idMatchitem = item.measure_cat.filter((id) => {
//           return id === cat.term_id
//         })
//         return idMatchitem.length > 0
//       })
//       articlesByCat.push(articlesByCatItem)
//     })
//     return articlesByCat;
//   },
// })


export const UseArticlesState = () => {
  const [articlesList, setArticlesList] = useRecoilState(articlesState);
  // const [articlesByCat, setArticlesByCat] = useRecoilState(articlesByCatState);
  const [articlesType, setArticlesType] = useRecoilState(articlesTypeState);

  return {
    articlesList, setArticlesList, articlesType, setArticlesType
  }
}
